<template>
    <b-modal
        v-if="orderAppResource && orderAppResource._uuid"
        size="lg"
        title-tag="h2"
        id="hslp-modal"
        :header-class="{ 'pb-0': !notProtected }"
        :modal-class="{ 'p-3 pt-0': currentComponent == 'v2' }"
        :hide-header-close="currentComponent == 'v2'"
        :title="notProtected ? 'We\'re your risk management partner' : ''"
        @hide="handleHide"
        hide-footer
        centered
    >
        <component
            :is="currentComponent"
            v-if="currentComponent"
            ref="HslpModalVersionChild"
            :orderAppResource="orderAppResource"
            v-bind="$props"
            @fetchOrder="fetchOrder"
        />
    </b-modal>
</template>
<script>
import {invitationMeta, notProtected} from "@helpers/order";
import {stateHasHSLP} from "@helpers/state";
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import {AppResourceSearch} from '@sellers-shield-home-protection/ss-core-js';
import FormErrorsMixin from '@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin';
import {useLookupsStore, useOrdersStore} from '@store';
import {mapState, mapActions} from 'pinia';


export default {
    name: 'HslpModal',
    components: {
        v1: async () => await import('./v1/HslpModal'),
        v2: async () => await import('./v2/HslpModal')
    },
    mixins: [
        FormErrorsMixin,
    ],
    props: {
        version: {
            type: String,
            default: null
        },
    },
    data: () => ({
        customLoading: false,
        orderAppResource: null,
    }),
    computed: {
        ...mapState(useLookupsStore, {
            getLuStatesAsArrayFromStore: 'getLuStatesAsArray',
        }),
        currentComponent() {
            return this.version || 'v1';//this.$componentsVersion[this.$options.name] || 'v1';
        },
        notProtected() {
            return notProtected(this.orderAppResource);
        },
    },
    methods: {
        ...mapActions(useLookupsStore, {
            fetchLuStatesToStore: 'fetchLuStateAppResourceSearch',
        }),
        ...mapActions(useOrdersStore, {
            setSelectedOrderDetailsToStoreByUuid: 'setSelectedOrderDetailsByUuid'
        }),
        async showHslpModal(event) {
            let stateId = event?.orderAppResource?.property?.stateId || (invitationMeta(event?.orderAppResource).property || {}).state;
            stateId && await this.fetchOrder(event.orderAppResource.uuid);
            if (stateId && notProtected(this.orderAppResource)) {
                const states = this.getLuStatesAsArrayFromStore;
                let stateData = states.find(state => state.id === parseInt(stateId)) || {};
                if (stateHasHSLP(JSON.parse(stateData?.meta || '{}'))) {
                    this.$nextTick(() => {
                        this.$bvModal.show('hslp-modal');
                    });
                }
            }
        },
        async fetchOrder(uuid) {
            let orderAppResource = new OrderAppResource({
                uuid: uuid,
            });

            await orderAppResource.find([
                'invitation',
                'homeSaleLegalProtection',
                'property',
                'property.state'
            ]);

            this.orderAppResource = orderAppResource || {};
            await this.setSelectedOrderDetailsToStoreByUuid(uuid);

        },
        handleHide() {
            this.$emit('hide', {notProtected: this.notProtected});
        },
    },
    async created() {
        await this.fetchLuStatesToStore();
    },
    mounted() {
        this.$bus.$on('show-hslp-modal', this.showHslpModal);
    },
    beforeDestroy() {
        this.$bus.$off('show-hslp-modal', this.showHslpModal);
    },
}
</script> 